import styles from './DotDivider.module.css';

import type { ReactElement } from 'react';

export const DotDivider = (): ReactElement => <div className={styles.root} />;
